/** Menu entries for the "expand config" side panel */
export const STYLES_FIELD: any[] = [
  { title: 'dieu_chinh_noi_dung', index: 1 },
  { title: 'dieu_chinh_vien', index: 2 },
  { title: 'hieu_ung', index: 3 },
  { title: 'nang_cao', index: 4 },
  { title: 'nen_bieu_tuong', index: 5 },
];

/** Translatable text fields for each step of the booking flow, grouped by section */
export const CONTENT_SECTIONS: any[] = [
  {
    title: 'chon_phong',
    fields: [
      { label: 'tieu_de_chon_phong', model: 'text_choose_room_title' },
      { label: 'xem_phong', model: 'text_view_room' },
      { label: 'gia_phong', model: 'text_room_price' },
      { label: 'da_chon', model: 'text_selected' },
      { label: 'chon', model: 'text_select' },
      { label: 'khach', model: 'text_guest' },
      { label: 'khong_co_du_lieu', model: 'text_empty' },
    ],
  },
  {
    title: 'dich_vu_mua_them',
    fields: [
      { label: 'tieu_de_dich_vu_mua_them', model: 'text_add_ons_title' },
      { label: 'thu_gon', model: 'text_collapse' },
      { label: 'xem_dich_vu', model: 'text_view_services' },
      { label: 'da_them', model: 'text_added' },
      { label: 'them', model: 'text_add' },
    ],
  },
  {
    title: 'thanh_toan',
    fields: [
      { label: 'tieu_de_thanh_toan', model: 'text_payment_title' },
      { label: 'tieu_de_phuong_thuc_thanh_toan', model: 'text_payment_method_title' },
      { label: 'ho', model: 'text_last_name' },
      { label: 'ten', model: 'text_first_name' },
      { label: 'email', model: 'text_email' },
      { label: 'dien_thoai', model: 'text_phone' },
      { label: 'quoc_gia', model: 'text_country' },
      { label: 'ghi_chu', model: 'text_note_placeholder' },
      { label: 'ghi_chu_thanh_toan', model: 'text_payment_note' },
      { label: 'dieu_khoan', model: 'text_terms' },
      { label: 'dieu_kien', model: 'text_conditions' },
      { label: 'bao_mat', model: 'text_privacy' },
    ],
  },
  {
    title: 'tom_tat',
    fields: [
      { label: 'tieu_de_tom_tat', model: 'text_summary_title' },
      { label: 'phong', model: 'text_room' },
      { label: 'sua', model: 'text_edit' },
      { label: 'dich_vu_kem_theo', model: 'text_auto_services' },
      { label: 'dich_vu_mua_them', model: 'text_add_on_services' },
      { label: 'chi_tiet', model: 'text_detail' },
      { label: 'tong_tien_phong', model: 'text_room_total' },
      { label: 'tong_chua_thue', model: 'text_subtotal' },
      { label: 'tong_thue', model: 'text_tax' },
      { label: 'tong_gio_hang', model: 'text_total' },
      { label: 'tiep_tuc', model: 'text_continue' },
      { label: 'thanh_toan', model: 'text_pay' },
    ],
  },
  {
    title: 'ma_giam_gia',
    fields: [
      { label: 'placeholder_o_nhap_ma', model: 'text_voucher_placeholder' },
      { label: 'nut_ap_dung', model: 'text_voucher_apply' },
      { label: 'nhan_da_ap_dung', model: 'text_voucher_applied' },
      { label: 'nut_xoa_ma', model: 'text_voucher_remove' },
      { label: 'thong_bao_ma_khong_hop_le', model: 'text_voucher_invalid' },
      { label: 'nhan_giam_gia', model: 'text_discount' },
    ],
  },
];

export const BOOKING_FLOW_LINK_SLOTS: any[] = [
  { key: 'link_next_to_service', label: 'lien_ket_toi_dich_vu' },
  { key: 'link_next_to_payment', label: 'lien_ket_toi_thanh_toan' },
  { key: 'link_back_to_choose_room', label: 'lien_ket_tro_ve_chon_phong' },
  { key: 'link_back_to_service', label: 'lien_ket_tro_ve_dich_vu' },
  { key: 'link_after_create_order',      label: 'lien_ket_sau_khi_tao_don' },
];